import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseTimesheetTaskApi = AiseaApiFactory.get("enterpriseTimesheetTask");

export default {

  async fetchAllCrewTasks({ commit }) {
    let res = await enterpriseTimesheetTaskApi.search();
    commit("SET_CREW_TASKS", res.data.list);
  },


};
